import { createSelector } from 'reselect';
import { fetchSuggestedCategoriesByCategoryID } from '@/redux/api/suggestedCategoryTiles';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const LOAD_SUGGESTED_CATEGORY_TILES_FAIL = 'la/domain/items/LOAD_SUGGESTED_CATEGORY_TILES_FAIL';
export const LOAD_SUGGESTED_CATEGORY_TILES_SUCCESS = 'la/domain/items/LOAD_SUGGESTED_CATEGORY_TILES_SUCCESS';

interface DefaultState {
    suggestedCategoryTiles: {
        facetImageUrl: string;
        filterFacetId: number;
        imageUrl: string;
        position: number;
        title: string;
        url: string;
    }[];
}

/* reducer */
const DEFAULT_STATE: DefaultState = {
    suggestedCategoryTiles: [],
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_SUGGESTED_CATEGORY_TILES_FAIL:
            return {
                ...state,
                suggestedCategoryTiles: [],
            };
        case LOAD_SUGGESTED_CATEGORY_TILES_SUCCESS:
            return {
                ...state,
                suggestedCategoryTiles: action.payload,
            };
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.suggestedCategoryTiles;

export const getSuggestedCategoryTiles = createSelector(stateSelector, (state) => {
    return state.suggestedCategoryTiles.filter(
        (categoryTile) => Boolean(categoryTile.imageUrl) || Boolean(categoryTile.facetImageUrl) || []
    );
});

/* ACTION CREATORS */
export const fetchSuggestedCategories = (categoryId: string) => async (dispatch: Function, getState: Function) => {
    const state = getState();
    const deployment = getDeployment(state);
    if (!categoryId) {
        return;
    }
    try {
        const response = await fetchSuggestedCategoriesByCategoryID({ categoryId, deployment });
        const suggestedCatsInPositionOrder = response.payload.sort((a, b) => {
            return a.position - b.position;
        });
        dispatch({
            payload: suggestedCatsInPositionOrder,
            type: LOAD_SUGGESTED_CATEGORY_TILES_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            meta: { categoryId },
            payload: error,
            type: LOAD_SUGGESTED_CATEGORY_TILES_FAIL,
        });
    }
};
